// extracted by mini-css-extract-plugin
export default {"-large":"VnmLg0_OqPrsJVzydiNj","label":"eGYjB5n83UeRsHgrl2FW","noMargin":"J8R6zl6Mrd8VENV8ozeQ"};